export class PushNotificationConfiguration {
  public oneSignalAppId: string;
  public firebaseProjectNumber: string;
}
